var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.navSelctType == 0 && _vm.searchedData.length
    ? _c(
        "div",
        { staticClass: "history-reacd" },
        [
          _vm.navSelctType == 0 && _vm.searchedData.length
            ? _c(
                "div",
                {
                  staticClass: "h-38 l-h-38 p-l-16 f-s-12",
                  staticStyle: {
                    color: "#999999",
                    "border-bottom": "1px solid #f2f2f2",
                  },
                },
                [_vm._v("聊天记录")]
              )
            : !_vm.keyWord
            ? [
                _vm._m(0),
                _c(
                  "div",
                  {
                    staticClass: "f-s-12 t-a-center",
                    staticStyle: { color: "#999999" },
                  },
                  [_vm._v("输入关键字开始搜索")]
                ),
              ]
            : _vm._e(),
          _c(
            "ul",
            _vm._l(_vm.searchedData, function (item, index) {
              return _vm.navSelctType == 0 && 3 > index
                ? _c(
                    "li",
                    {
                      key: index,
                      staticClass: "flex cursor-pointer bg-g-50-hover",
                      on: {
                        click: function ($event) {
                          return _vm.viewDetail(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-table-cell v-a-middle h-100-p w-64",
                          staticStyle: { "text-align": "center" },
                        },
                        [
                          item.convType == "PERSON" &&
                          item.fromAccount.length == 32
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                                  staticStyle: {
                                    "background-color": "#653EB3",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getShortNickname(
                                        item.fromNick || item.fromAccount
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.convType == "PERSON" &&
                          item.fromAccount.length < 32
                            ? _c("img", {
                                staticStyle: { width: "40px", height: "40px" },
                                attrs: {
                                  src: require("@/assets/images/im/kefu.svg"),
                                },
                              })
                            : _vm._e(),
                          item.convType == "TEAM"
                            ? _c("img", {
                                staticStyle: { width: "40px", height: "40px" },
                                attrs: {
                                  src: require("@/assets/images/im/team-cus.png"),
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "content",
                          style: { width: _vm.listWidth + "px" },
                        },
                        [
                          _c("div", { staticClass: "flex header" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-s-nowrap t-o-ellipsis o-hidden f-s-12",
                              },
                              [
                                _vm._v(
                                  _vm._s(item.fromNick || item.fromAccount) +
                                    " > " +
                                    _vm._s(item.toNick || item.to)
                                ),
                              ]
                            ),
                          ]),
                          _c("div", {
                            staticClass:
                              "m-r-4 w-s-nowrap t-o-ellipsis o-hidden",
                            domProps: { innerHTML: _vm._s(item.html) },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
          _vm.hasMore
            ? _c(
                "div",
                {
                  staticClass:
                    "h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center cursor-pointer",
                  staticStyle: {
                    color: "#653EB3",
                    "border-bottom": "1px solid #f2f2f2",
                  },
                  on: { click: _vm.selectedHistoryRecord },
                },
                [
                  _c("span", { staticClass: "d-block" }, [
                    _vm._v("查看更多相关聊天记录"),
                  ]),
                  _c("img", {
                    staticClass: "d-block",
                    staticStyle: { width: "8px", height: "14px" },
                    attrs: {
                      src: require("@/assets/images/im/arrow-right@2x.png"),
                    },
                  }),
                ]
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "t-a-center", staticStyle: { margin: "68px auto auto" } },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/images/im/kong-order@2x.png"),
            width: "155px",
            height: "104px",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }